export default [
  {
    target: '#main-title',
    content:
      'Welcome to the Philly School Experience Survey — Response Rate page. Here you can find out how student, parent/guardian, teacher, and principal response rates compare across schools and years.',
    params: { enableScrolling: true },
    offset: -400,
  },
  {
    target: '#nav-topics',
    content:
      'This website is divided into three pages. You can navigate to any of these pages at any time.',
    params: { enableScrolling: true },
    offset: -400,
  },
  {
    target: '#nav-about',
    content:
      'Additionally, there is an "About" page that provides details about how the Philly School Experience Surveys were designed, administered, and processed.',
    params: { enableScrolling: true },
    offset: -400,
  },
  {
    target: '#main-content-side',
    content:
      'In the area below you can view response rate data for each of the respondent groups. By default, response rates include all schools (district, charter, and alternative).',
    params: { enableScrolling: true },
    offset: -400,
  },
  {
    target: '#main-filter-panel',
    content:
      'On this panel you can find a number of filters to narrow down the displayed data.',
    params: { enableScrolling: true },
    offset: -400,
  },
  {
    target: '#main-school-filters',
    content:
      'Use the filters to narrow down school or student characteristics.',
    params: { enableScrolling: true },
    offset: -400,
  },
  {
    target: '#main-school-filter',
    content: 'Use the school filter to choose one or more schools.',
    params: { enableScrolling: true },
    offset: -400,
  },
  {
    target: '#main-tour-button',
    content: 'Press here to take this tour again.',
    params: { enableScrolling: true },
    offset: -400,
  },
]
